<template>
  <div id="app">
    <main-menu />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import MainMenu from "@/components/MainMenu";
import Footer from "@/components/Footer";

export default {
  components: { MainMenu, Footer }
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  > section,
  > div {
    flex-grow: 1;
  }

  header,
  footer,
  > section,
  > div {
    width: 100%;
    flex-shrink: 0;
  }
}
</style>
